(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sq-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sq-pack-picker')) {
    class SqPackPicker extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('change', (event) => this.onChange(event), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

        this.querySelectorAll('.sq-pack__card').forEach((card) => {
          card.classList.toggle('is-selected', card.contains(input));
        });

        // Transmet le choix au sélecteur de variantes natif du thème.
        const section = this.closest('.shopify-section') || document;
        const nativeInput = section.querySelector(
          `variant-picker[data-product-id="${this.dataset.productId}"] input[data-variant-id="${input.value}"]`
        );
        if (nativeInput && !nativeInput.checked) nativeInput.click();
      }
    }
    customElements.define('sq-pack-picker', SqPackPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sq-unit-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sq-unit-price')) {
    class SqUnitPrice extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        try {
          this.prices = JSON.parse(this.dataset.prices);
        } catch {
          return;
        }
        // Les boutons radio du sélecteur de variantes portent data-variant-id.
        const section = this.closest('.shopify-section') || document;
        section.addEventListener(
          'change',
          (event) => {
            const id = event.target?.dataset?.variantId;
            if (id && this.prices[id]) this.querySelector('[data-unit-price]').textContent = this.prices[id];
          },
          { signal: this.controller.signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    }
    customElements.define('sq-unit-price', SqUnitPrice);
  }
  } catch(e) { console.error(e); }
})();

})();
